import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/admin/prodmob-webapp/mob-webapp/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/admin/prodmob-webapp/mob-webapp/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/admin/prodmob-webapp/mob-webapp/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/admin/prodmob-webapp/mob-webapp/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/admin/prodmob-webapp/mob-webapp/src/components/ui/Button/Button.module.scss");
;
import(/* webpackMode: "eager" */ "/home/admin/prodmob-webapp/mob-webapp/src/app/[locale]/(mobility)/(content)/faq/Faq.module.scss");
